import React from 'react';
import { VerificationProtocolState } from './types';
import { VerifyAccent } from './theme';

interface Props {
  protocolState: VerificationProtocolState;
  accent: VerifyAccent;
}

/**
 * Protocol-state strip: "In Network · <node>", galaxy population, and (only when
 * real data exists) In Cycle. Per the Phase C notes, inCycle:null omits the line
 * entirely rather than rendering "Unknown".
 */
const VerifyProtocolState: React.FC<Props> = ({ protocolState, accent }) => {
  const pop = protocolState.galaxyPopulation;
  return (
    <div className="border-x border-gray-200 px-5 py-4 bg-white">
      {protocolState.inNetwork && (
        <p className={`text-base font-semibold ${accent.text}`}>
          In Network · {protocolState.inNetwork}
        </p>
      )}

      {/* In Cycle omitted entirely while inCycle is null (v0). */}
      {protocolState.inCycle && (
        <p className="text-base font-semibold text-gray-800 mt-1">
          In Cycle · {protocolState.inCycle}
        </p>
      )}

      {typeof pop === 'number' && (
        <p className="text-sm text-gray-500 mt-1">
          Galaxy census: {pop} registered
        </p>
      )}
    </div>
  );
};

export default VerifyProtocolState;
